"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildOutgoingDirectCallerRequestInterceptor = void 0;
const commons_logs_1 = require("@deliverr/commons-logs");
const DIRECT_CALLER_HEADER_KEY = "x-direct-caller";
const buildOutgoingDirectCallerRequestInterceptor = () => {
    return async (requestConfig) => {
        try {
            const { outgoingDirectCaller } = commons_logs_1.asyncLocalStorageRecords;
            if (outgoingDirectCaller) {
                const headerValue = outgoingDirectCaller.toString();
                requestConfig.headers[DIRECT_CALLER_HEADER_KEY] = headerValue;
                if (headerValue === "unknown") {
                    commons_logs_1.log.warn({ fn: exports.buildOutgoingDirectCallerRequestInterceptor.name, issue: "outgoingDirectCaller_unknown" }, "OutgoingDirectCaller set to 'unknown' in the context, please update your service to properly initialize this value.");
                }
            }
            else {
                commons_logs_1.log.warn({ fn: exports.buildOutgoingDirectCallerRequestInterceptor.name, issue: "outgoingDirectCaller_not_set" }, "OutgoingDirectCaller not set in the context, please update your service to leverage this functionality.");
            }
        }
        catch (err) {
            commons_logs_1.log.error({ fn: exports.buildOutgoingDirectCallerRequestInterceptor.name, issue: "interceptor_failed", err }, "couimet screwed up with bad code, please reach out on #omnichannel-observability Slack channel to report the problem");
        }
        return requestConfig;
    };
};
exports.buildOutgoingDirectCallerRequestInterceptor = buildOutgoingDirectCallerRequestInterceptor;
//# sourceMappingURL=buildOutgoingDirectCallerRequestInterceptor.js.map